import { ProductCode } from "./product-code.constant";

export enum ServiceRequest {
    SCREEN_CRACK = "Screen Crack",
    ACCIDENTAL_DAMAGE = "Accidental and Liquid Damage",
    LOST_THEFT = "Lost/Attended Theft",
    ACCIDENTAL_DAMAGE_LIQUID_DAMAGE = "Accidental Damage & Liquid Damage",
    DAMAGE_TRANSIT = "Damage In Transit",
    MANUFACTURER_DEFECTS = "Manufacturer Defects",

    CHUBB_ACCIDENTAL_DAMAGE = "AccidentalDamage",
    CHUBB_THEFT = "Theft",

    MEDICAL_EXPENSES = "Medical Expenses",
    ITEM_PURCHASED_VALUE_REIMBURSEMENT = "Item Purchased Value Reimbursement",
    EMERGENCY_HOSPITALIZATION = "Emergency Hospitalization",
    ACCIDENTAL_DEATH = "Accidental Death",
}

export const SERVICE_REQUEST_OPTIONS: Partial<Record<ProductCode, ServiceRequest[]>> = {
    [ProductCode.EP]: [
        ServiceRequest.ACCIDENTAL_DAMAGE_LIQUID_DAMAGE,
        ServiceRequest.CHUBB_THEFT,
        ServiceRequest.DAMAGE_TRANSIT,
        ServiceRequest.MANUFACTURER_DEFECTS,
    ],
    [ProductCode.GP]: [
        ServiceRequest.ACCIDENTAL_DAMAGE_LIQUID_DAMAGE,
        ServiceRequest.CHUBB_THEFT,
        ServiceRequest.DAMAGE_TRANSIT,
        ServiceRequest.MANUFACTURER_DEFECTS,
    ],
    [ProductCode.TM_MP]: [
        ServiceRequest.ACCIDENTAL_DAMAGE_LIQUID_DAMAGE,
        ServiceRequest.CHUBB_THEFT,
        ServiceRequest.DAMAGE_TRANSIT,
        ServiceRequest.MANUFACTURER_DEFECTS,
    ],
    [ProductCode.AP]: [
        ServiceRequest.MEDICAL_EXPENSES,
        ServiceRequest.ITEM_PURCHASED_VALUE_REIMBURSEMENT,
        ServiceRequest.EMERGENCY_HOSPITALIZATION,
        ServiceRequest.ACCIDENTAL_DEATH,
    ],
    // [16/7/2026] CH_EP/CH_GP fulfil under TMIM since the Chubb exit — generic vocabulary. The legacy
    // Chubb form does not read this constant (its incident types are hardcoded in ChubbRequestDetailsComponent).
    [ProductCode.CH_GP]: [
        ServiceRequest.ACCIDENTAL_DAMAGE_LIQUID_DAMAGE,
        ServiceRequest.CHUBB_THEFT,
        ServiceRequest.DAMAGE_TRANSIT,
        ServiceRequest.MANUFACTURER_DEFECTS,
    ],
    [ProductCode.CH_EP]: [
        ServiceRequest.ACCIDENTAL_DAMAGE_LIQUID_DAMAGE,
        ServiceRequest.CHUBB_THEFT,
        ServiceRequest.DAMAGE_TRANSIT,
        ServiceRequest.MANUFACTURER_DEFECTS,
    ],
    // [16/7/2026] CH_MP retired (zero policies)
    //[ProductCode.CH_MP]: [ServiceRequest.CHUBB_ACCIDENTAL_DAMAGE, ServiceRequest.CHUBB_THEFT],
};
